import { useTranslation } from 'react-i18next';

import Collapse from 'components/collapse/Collapse';
import { MESSAGES_SENT_TO_PROPERTY_MANAGERS_TEMPLATE_ROWS } from '../SystemTemplatesTab.constants';
import SystemTemplatesTable from './common/SystemTemplatesTable';

const MessagesSentToPropertyManagersSection = () => {
  const { t } = useTranslation();

  return (
    <Collapse
      data-testid="messages-sent-to-property-managers"
      defaultExpanded
      label={t(
        'pageAutomations.systemTemplates.sections.messagesSentToPropertyManagers',
      )}
      variant="card"
    >
      <SystemTemplatesTable
        data-testid="messages-sent-to-property-managers-table"
        data={MESSAGES_SENT_TO_PROPERTY_MANAGERS_TEMPLATE_ROWS}
      />
    </Collapse>
  );
};

export default MessagesSentToPropertyManagersSection;
